import cn from 'classnames'
import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { InformationCircleIcon } from '@heroicons/react/16/solid'
import { Spinner } from '@egw/components'
import { useVgsShow } from '../../context/vsg-context-provider'

export const CardNumberAttribute: FC = () => {
  const { t } = useTranslation('features-account')
  const { cardRevealed, isLoading, toggleShowCard, showError } = useVgsShow()

  return (
    <div
      id="cardNumberAttribute"
      className="!text-base max-md:px-2 py-4 border-b transition-all duration-200 cursor-pointer border-light"
    >
      <div className="flex">
        <span className="flex-grow mr-2.5">{t('debit_card.card_number')}</span>
        {isLoading ? <Spinner className="w-6 h-6 text-gray-100 animate-spin dark:white fill-white" /> : null}
        <button
          type="button"
          id="revealCard"
          className={cn(
            'ml-4 text-btnLinkText hover:text-btnLinkTextHover active:text-btnLinkTextActive disabled:text-btnLinkTextDisabled disabled:no-underline disabled:cursor-default hover:underline font-semibold border-transparent cursor-pointer',
            {
              'cursor-not-allowed': isLoading, // Disable when loading
            },
          )}
          disabled={isLoading}
          onClick={toggleShowCard}
        >
          {cardRevealed || isLoading ? t('debit_card.hide') : t('debit_card.show')}
        </button>
      </div>
      {showError ? (
        <div className="flex bg-alertErrorBg p-3 rounded-md">
          <InformationCircleIcon className="w-6 h-6 fill-red-500" />
          <p className="text-sm text-alertErrorText ml-2">{t('debit_card.show_card_fail')} </p>
        </div>
      ) : null}
    </div>
  )
}
